/**
 * List Schema of AdminConfig
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {AdminConfig} from '@/model/resource/AdminConfig'

/* TODO: review generated schema */
export class ListAdminConfigSchema extends Schema {
  readonly name = 'ListAdminConfig'

  readonly fieldSet: FieldSet<AdminConfig> = {
    idConfigPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    autorizarMesmoVencido: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.autorizarMesmoVencido),
      },
    }),
    senhaApp: (): FieldComponent => ({
      is: Component.Render,
    }),
    senhaPainel: (): FieldComponent => ({
      is: Component.Render,
    }),
    indiqueUmAmigo: (): FieldComponent => ({
      is: Component.Render,
    }),
    boasVindas: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
